if (typeof Object.create !== 'function') {
    Object.create = function (obj) {
        function F() {
        };
        F.prototype = obj;
        return new F();
    };
}

(function ($, window, document, undefined) {
    var InstallmentManager = {
        init: function (options, elem) {
            var self = this;

            self.elem = elem;
            self.$elem = $(elem);

            self.options = $.extend({}, $.fn.installmentManager.options, options);

            self.defaults = $.fn.installmentManager.defaults;

            self.$elem.on('input', numberChanged);

            self.$elem.on('cartUpdated', cartUpdated);

            function numberChanged() {
                var card_number = this.value;

                card_number = card_number.replace(/\D/g, '');

                if (card_number.length >= 8) {

                    self.defaults.bin = card_number.substring(0, 8);

                } else {

                    self.defaults.previousBin = false;

                    self.options.error(false);

                }

                if (card_number.length >= 8 && self.defaults.bin !== self.defaults.previousBin) {

                    if (self.defaults.timeoutFn) clearTimeout(self.defaults.timeoutFn);

                    if (self.defaults.xhrRequest) self.defaults.xhrRequest.abort();

                    self.defaults.timeoutFn = setTimeout(function () {

                        self.defaults.xhrRequest = $.ajax({
                            type: "POST",
                            url: self.options.endpoint,
                            data: {'card_number': card_number, '_token': self.options.token},
                            dataType: 'json',
                            success: function (response) {

                                self.options.success(response);

                            },
                            error: function (response) {

                                self.options.error(response);

                            },
                            complete: function (response) {

                                self.options.complete(response);

                                self.defaults.previousBin = self.defaults.bin;

                            }
                        });

                    }, self.defaults.timeout);

                }
            }

            function cartUpdated() {
                var card_number = this.value;

                card_number = card_number.replace(/\D/g, '');

                if (self.defaults.timeoutFn) clearTimeout(self.defaults.timeoutFn);

                if (self.defaults.xhrRequest) self.defaults.xhrRequest.abort();

                if (card_number.length >= 8) {

                    self.defaults.bin = card_number.substring(0, 8);

                } else {

                    self.defaults.previousBin = false;

                    self.options.error(false);

                }

                self.defaults.timeoutFn = setTimeout(function () {

                    self.defaults.xhrRequest = $.ajax({
                        type: "POST",
                        url: self.options.endpoint,
                        data: {'card_number': card_number, '_token': self.options.token},
                        dataType: 'json',
                        success: function (response) {

                            self.options.success(response);

                        },
                        error: function (response) {

                            self.options.error(response);

                        },
                        complete: function (response) {

                            self.options.complete(response);

                            self.defaults.previousBin = self.defaults.bin;

                        }
                    });

                }, self.defaults.timeout);

            }
        },


    };

    $.fn.installmentManager = function (options) {
        return this.each(function () {
            var installmentManager = Object.create(InstallmentManager);

            installmentManager.init(options, this);

            $.data(this, 'installmentManager', installmentManager);

        });
    };

    $.fn.installmentManager.defaults = {
        xhrRequest: false,
        timeoutFn: false,
        timeout: 1000,
        bin: false,
        previousBin: false,
    };

    $.fn.installmentManager.options = {
        token: false,
        endpoint: false,
        success: function ({}) {
        },
        error: function ({}) {
        },
        complete: function ({}) {
        },
    };

})(jQuery, window, document);
